import React, { useState } from 'react';
import { SearchIcon, EditIcon, Trash2Icon, BookOpenIcon, CalendarIcon } from 'lucide-react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
interface Note {
  id: string;
  title: string;
  content: string;
  courseTitle: string;
  lessonTitle: string;
  date: string;
}
const notesData: Note[] = [{
  id: '1',
  title: 'Effetto serra e gas climalteranti',
  content: "Le principali cause dell'effetto serra sono l'aumento di CO2, metano e altri gas serra nell'atmosfera. L'attività umana ha accelerato questo processo...",
  courseTitle: 'Climate Change 101',
  lessonTitle: 'Lezione 3 - Cause del cambiamento climatico',
  date: '15 Dic 2024'
}, {
  id: '2',
  title: 'Isolamento termico della casa',
  content: "Per migliorare l'efficienza energetica: 1) Isolare pareti e tetto 2) Sostituire infissi vecchi 3) Installare termostati intelligenti...",
  courseTitle: 'Casa Efficiente',
  lessonTitle: 'Lezione 2 - Ridurre i consumi',
  date: '10 Dic 2024'
}, {
  id: '3',
  title: 'Calcolo emissioni trasporti',
  content: 'Formula per calcolare le emissioni: km percorsi × fattore emissione del mezzo. Auto benzina: ~120g CO2/km, Treno: ~14g CO2/km...',
  courseTitle: 'Mobilità Sostenibile',
  lessonTitle: 'Lezione 4 - Impatto ambientale',
  date: '5 Dic 2024'
}, {
  id: '4',
  title: 'Obiettivi Agenda 2030',
  content: 'I 17 SDGs delle Nazioni Unite: 1) Sconfiggere la povertà 2) Sconfiggere la fame 3) Salute e benessere... Focus su obiettivo 13: Lotta contro il cambiamento climatico',
  courseTitle: 'Climate Change 101',
  lessonTitle: 'Lezione 1 - Introduzione',
  date: '1 Dic 2024'
}];
const NotesPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [notes, setNotes] = useState(notesData);
  const filteredNotes = notes.filter(note => note.title.toLowerCase().includes(searchQuery.toLowerCase()) || note.content.toLowerCase().includes(searchQuery.toLowerCase()) || note.courseTitle.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleDelete = (noteId: string) => {
    if (window.confirm('Sei sicuro di voler eliminare questa nota?')) {
      setNotes(notes.filter(note => note.id !== noteId));
    }
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-2859">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2860">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2861"></div>
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2862">
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2863">
            <Sidebar activePage="formazione" data-id="element-2864" />
          </div>
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2865">
        <Sidebar activePage="formazione" data-id="element-2866" />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2867">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2868" />

        <main className="flex-1 overflow-y-auto p-4 md:p-8 bg-gray-50" data-id="element-2869">
          <div className="max-w-4xl mx-auto" data-id="element-2870">
            {/* Header */}
            <div className="mb-6" data-id="element-2871">
              <h1 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-2872">
                Le mie Note
              </h1>
              <p className="text-sm text-gray-600 font-normal" data-id="element-2873">
                Tutte le note prese durante i corsi
              </p>
            </div>

            {/* Search */}
            <div className="mb-6" data-id="element-2874">
              <div className="relative" data-id="element-2875">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2876">
                  <SearchIcon size={18} className="text-gray-400" data-id="element-2877" />
                </div>
                <input type="text" placeholder="Cerca nelle note..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg bg-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-green-600 text-sm" data-id="element-2878" />
              </div>
            </div>

            {/* Notes List */}
            {filteredNotes.length > 0 ? <div className="space-y-4" data-id="element-2879">
                {filteredNotes.map(note => <div key={note.id} className="bg-white rounded-xl border border-gray-200 p-5 hover:border-green-600 transition-colors" data-id="element-2880">
                    <div className="flex items-start justify-between mb-3" data-id="element-2881">
                      <div className="flex-1" data-id="element-2882">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-2883">
                          📝 {note.title}
                        </h3>
                        <p className="text-sm text-gray-600 line-clamp-2 mb-3" data-id="element-2884">
                          {note.content}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center justify-between pt-3 border-t border-gray-100" data-id="element-2885">
                      <div className="flex flex-col gap-1" data-id="element-2886">
                        <div className="flex items-center text-xs text-gray-600" data-id="element-2887">
                          <BookOpenIcon size={14} className="mr-1.5" data-id="element-2888" />
                          <span className="font-medium" data-id="element-2889">
                            {note.courseTitle}
                          </span>
                          <span className="mx-1.5" data-id="element-2890">•</span>
                          <span data-id="element-2891">{note.lessonTitle}</span>
                        </div>
                        <div className="flex items-center text-xs text-gray-500" data-id="element-2892">
                          <CalendarIcon size={14} className="mr-1.5" data-id="element-2893" />
                          <span data-id="element-2894">{note.date}</span>
                        </div>
                      </div>

                      <div className="flex items-center gap-2" data-id="element-2895">
                        <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2896">
                          <EditIcon size={16} className="text-gray-600" data-id="element-2897" />
                        </button>
                        <button onClick={() => handleDelete(note.id)} className="p-2 hover:bg-red-50 rounded-lg transition-colors" data-id="element-2898">
                          <Trash2Icon size={16} className="text-red-600" data-id="element-2899" />
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div> /* Empty State */ : <div className="bg-white rounded-xl border border-gray-200 p-12 text-center" data-id="element-2900">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2901">
                  <BookOpenIcon size={32} className="text-gray-400" data-id="element-2902" />
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-2903">
                  {searchQuery ? 'Nessuna nota trovata' : 'Nessuna nota ancora'}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-2904">
                  {searchQuery ? 'Prova a cercare con parole chiave diverse' : 'Le note che prenderai durante i corsi appariranno qui'}
                </p>
              </div>}
          </div>
        </main>
      </div>
    </div>;
};
export default NotesPage;